/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import INITIAL_STATE from './initial_state';

import { FollowupOnlineSearchTypes, FollowupOnlineSearchState } from './types';

const reducer: Reducer<FollowupOnlineSearchState> = (
  state = INITIAL_STATE,
  { type, value, field, currentPage, postsPerPage },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case FollowupOnlineSearchTypes.CLEAR_FILTER:
        draft.followupOnlineSearch.filters = INITIAL_STATE.followupOnlineSearch.filters;
        break;

      case FollowupOnlineSearchTypes.CHANGE_VALUE:
        draft.followupOnlineSearch.filters = {
          ...state.followupOnlineSearch.filters,
          [field]: value,
        };
        break;

      case FollowupOnlineSearchTypes.UPDATE_CURRENT_PAGE:
        draft.followupOnlineSearch.currentPage = currentPage;
        break;

      case FollowupOnlineSearchTypes.UPDATE_POSTS_PER_PAGE:
        draft.followupOnlineSearch.postsPerPage = postsPerPage;
        break;

      case FollowupOnlineSearchTypes.UPDATE_STORE_FIELDS:
        if (!state.followupOnlineSearch.currentPage)
          draft.followupOnlineSearch.currentPage = INITIAL_STATE.followupOnlineSearch.currentPage;

        if (!state.followupOnlineSearch.postsPerPage)
          draft.followupOnlineSearch.postsPerPage = INITIAL_STATE.followupOnlineSearch.postsPerPage;
        break;

      default:
        break;
    }
  });
};

export default reducer;
